import {Component, HostBinding, OnInit} from '@angular/core';
import {FeatureCreateCommand, FeaturesDataService} from '../services/features.data.service';
import {GeneralService, SnackbarService} from 'app/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Location} from '@angular/common';
import {ActivatedRoute} from '@angular/router';
import {Observable} from 'rxjs';
import {HttpErrorResponse} from '@angular/common/http';

@Component({
    selector: 'sh-features-create',
    templateUrl: './features-edit.component.html',
    styleUrls: ['./features-edit.component.scss']
})
export class FeaturesEditComponent implements OnInit {

    @HostBinding('class') classes = 'flex flex-grow scroll-hide';

    editingForm: FormGroup;
    isEditing = false;

    types = ['Text', 'Boolean', 'Select'];
    featureId: number;

    selectFields: {name: string}[];
    fieldsIndexesErrors: number[] = [];
    isLoading = false;

    navigationBackArray = ['metadata', 'settings', 'features'];

    constructor(
        public dataService: FeaturesDataService,
        public generalService: GeneralService,
        private featuresDataService: FeaturesDataService,
        private formBuilder: FormBuilder,
        private snackBar: SnackbarService,
        private _location: Location,
        private route: ActivatedRoute,
    ) {
    }

    ngOnInit(): void {
        this.featureId = this.route.snapshot.params.id as number;

        this.editingForm = this.formBuilder.group({
            name: ['', Validators.required],
            type: ['Text', Validators.required]
        });
        this.selectFields = [{name: ''}];

        const createObs: Observable<FeatureCreateCommand> = this.dataService.getById(this.featureId);
        this.isLoading = true;
        createObs
            .subscribe(
                res => {
                    this.editingForm.controls['name'].setValue(res.name);
                    this.editingForm.controls['type'].setValue(res.type);
                    this.selectFields = res.possibleValues
                        ? res.possibleValues.map(possibleValue => ({name: possibleValue}))
                        : [{name: ''}];
                },
                () => {
                    this.snackBar.info('Wystąpił błąd podczas pobierania danych.');
                    this._location.back();
                },
                () => {
                    this.isLoading = false;
                }
            );
    }

    onSubmit() {
        if (!this.editingForm.valid) {
            this.snackBar.info('Wszystkie pola muszą być wypełnione.');
            return;
        }
        const form = this.editingForm.value;
        form.id = this.featureId;
        form.possibleValues = form.type === 'Select' ? this.possibleValuesFromSelectFields(this.selectFields) : undefined;
        let isValidateError = false;
        if (form.type === 'Select') {
            form.possibleValues.forEach((possibleValue, index) => {
                // Check if fields are empty
                if (possibleValue === '') {
                    isValidateError = true;
                    this.snackBar.info('Wartości pól nie mogą być puste');
                    return;
                }
                // Check if the fields are repeated
                form.possibleValues.forEach((possibleValueCheck, indexCheck) => {
                    if (possibleValueCheck === possibleValue && index !== indexCheck) {
                        this.fieldsIndexesErrors = [index, indexCheck];
                        isValidateError = true;
                        this.snackBar.info('Wartości pól nie mogą się powtarzać');
                        return;
                    }
                });
                if (isValidateError) {
                    return;
                }
            });
        }
        if (isValidateError) {
            return;
        }
        const createObs: Observable<any> = this.dataService.update(form);
        this.isEditing = true;
        createObs
            .subscribe(
                () => {},
                err => this.featureError(err),
                () => this.featureEdited()
            );
    }

    private createData(): FeatureCreateCommand {
        const data = this.editingForm.value;
        if (data.type === 'Select') {
            data.possibleValues = data.possibleValues.map(possibleValue => (possibleValue.name));
        } else {
            data.possibleValues = undefined;
        }
        return data;
    }

    addField(index: number) {
        this.selectFields.splice(index + 1, 0, {name: ''});
    }

    removeField(fieldIndex: number) {
        this.selectFields = this.selectFields.filter((field, index) => index !== fieldIndex);
    }

    private featureEdited(): void {
        this.snackBar.info('Cecha została edytowana.');
        this._location.back();
    }

    private featureError(err: HttpErrorResponse) {
        this.isEditing = false;
        if (err.status) {
            this.snackBar.info('Podczas zapisywania wystąpił błąd.');
            return;
        }
    }

    private possibleValuesFromSelectFields(selectFields: {name: string}[]): string[] {
        return selectFields.map((field) => (
            field.name
        ));
    }

    public navigationBack(): void {
        this.generalService.navigateTo(this.navigationBackArray);
    }
}
